//import packages from node modules
import React, { useRef, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { reduxForm, Field, change } from 'redux-form'
import { withRouter } from 'react-router-dom'

//import utility functions

import {
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../../utilities/function/common'

import {
  getDataFromURL
} from '../../../../utilities/function/urlparams'

import {
  getAttributes,
  isFirstInvoicePromo
} from '../../../../utilities/function/configuration'

import {
  getBillingCycleDataFromProductConfig,
  getCycle,
  getPriceByBillingCycleName
} from '../../../../utilities/function/billingCycle'


//import shared components

import RadioButton from '../../form/radiobutton'
import SolidButton from '../../button/solidbutton'
import Heading from '../../typography/heading'
import Description from '../../typography/description'
import { updateConfig } from '../../../../app/action'
import {MONTHLY} from "../../../siteconnector";


//Form for Main Default Exported Component

let SelectBillingCycleForm = (props) => {
  const { handleSubmit,productConfig } = props
  const getList = () => {
    const originalPriceList = getBillingCycleDataFromProductConfig(productConfig,true)
    const salePriceList = getBillingCycleDataFromProductConfig(productConfig)

    const getOriginalPrice = (cyclename) => {
      if(originalPriceList && originalPriceList.length){
        const originalPrice = originalPriceList.find(price=>price.name===cyclename)
        if(originalPrice && originalPrice.price){
          return parseFloat(originalPrice.price.replace(",",""))
        }
      }
      return null
    }

    const getSalePrice = (cyclename) => {
      if(salePriceList && salePriceList.length){
        const salePrice = salePriceList.find(price=>price.name===cyclename)
        if(salePrice && salePrice.price){
          return parseFloat(salePrice.price.replace(",",""))
        }
      }
      return null
    }

    if (originalPriceList && originalPriceList.length > 0) {
      return originalPriceList.map((billing_cyle) => {
        const { name, price, billing_cycle_id } = billing_cyle
        const isSaving = () => {
          const diff = getOriginalPrice(name) - getSalePrice(name)
          return diff && diff > 0
        }
        const getRadioLeft = () => {
          const normal = getOriginalPrice(name)
          const renderDefault = () => {
            const getSave = () => {
              const sale = getSalePrice(name)
              const diff = normal - sale
              if (diff > 0) {
                return `You save $${Math.round(diff).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}`
              }
              return null
            }
            return (
                <div className='of-select-billing-cycle__radio-left'>
                  <span className='of-select-billing-cycle__radio-text text-font-1-100'>{name}</span>
                  {getSave() ? <span
                      className='of-select-billing-cycle__radio-tag status-background-3-100'>{getSave()}</span> : ''}
                </div>
            )
          }
          const renderOnPromo = () => {
            const normalPrice = getOriginalPrice(name)
            const promoPrice = getSalePrice(name)
            const savePrice = normalPrice - promoPrice
            if (savePrice) {
              return (
                  <div className='of-select-billing-cycle__radio-left'>
                    <span className='of-select-billing-cycle__radio-text text-font-1-100'>{name}</span>
                    {savePrice ? <span
                        className='of-select-billing-cycle__radio-tag status-background-3-100'>You Save ${savePrice.toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</span> : <></>}
                  </div>
              )
            }
            return (renderDefault())
          }

          if(isFirstInvoicePromo(productConfig)){
            return (renderOnPromo())
          }
          return (renderDefault())
        }
        const getRadioRight = () => {
          const renderDefault = () => {
            const getOldPrice = () => {
              if (isSaving()) {
                return (
                    <div
                        className='of-select-billing-cycle__price of-select-billing-cycle__price--old clearfix text-font-4-100'>
                <span
                    className='of-select-billing-cycle__price-amount text-font-4-100'>${getOriginalPrice(name).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</span>
                      <span className='of-select-billing-cycle__price-cycle text-font-4-100'>{getCycle(name)}</span>
                    </div>
                )
              }
              return (<></>)
            }
            if (price && parseFloat(price) >= 0) {
              return (
                  <div className='of-select-billing-cycle__radio-right'>
                    <div className='of-select-billing-cycle__price clearfix'>
                  <span
                      className={`of-select-billing-cycle__price-amount ${isSaving() ? 'status-font-3-100' : 'text-font-1-100'}`}>${parseFloat(getSalePrice(name)).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</span>
                      <span
                          className={`of-select-billing-cycle__price-cycle ${isSaving() ? 'status-font-3-100' : 'text-font-1-100'}`}>{getCycle(name)}</span>
                    </div>
                    {getOldPrice()}
                  </div>
              )
            }
            return (<></>)
          }
          const renderOnPromo = () => {
            //if(productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)){
              const oldPrice = getOriginalPrice(name)
              let newPrice = getSalePrice(name)
              const diff = parseFloat(newPrice) -  parseFloat(oldPrice)
              if(diff){
                const desc = `(You'll pay $${parseFloat(oldPrice).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}${getCycle(name)} after the first invoice)`
                return ( <div className='of-select-billing-cycle__radio-right of-select-billing-cycle-firstinvoice'>
                  <div className='of-select-billing-cycle__price clearfix of-select-billing-cycle-firstinvoice__top'>
                    <div className={'of-select-billing-cycle-firstinvoice__old-price text-font-4-100'}>
                      <span className={`of-select-billing-cycle__price-amount`}>${parseFloat(oldPrice).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</span><span className={`of-select-billing-cycle__price-cycle`}>{getCycle(name)}</span>
                    </div>
                    <div className={'of-select-billing-cycle-firstinvoice__new-price status-font-3-100'}>
                      <span className={`of-select-billing-cycle__price-amount`}>${parseFloat(newPrice).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</span><span className={`of-select-billing-cycle__price-cycle`}>{getCycle(name)}</span>
                    </div>
                  </div>
                  <div className='of-select-billing-cycle__price clearfix of-select-billing-cycle-firstinvoice__bottom'>
                    <div className={'of-select-billing-cycle-firstinvoice__description text-font-1-60'}>{desc}</div>
                  </div>
                </div>)
              }
            //}
            return (renderDefault())
          }
          if(isFirstInvoicePromo(productConfig)){
            return (renderOnPromo())
          }
          return (renderDefault())
        }
        return (
          {
            value: billing_cycle_id,
            custom: {
              left: getRadioLeft,
              right: getRadioRight
            }
          }
        )
      })
    }
    return null
  }
  return (
    <form onSubmit={handleSubmit} className={`of-select-billing-cycle-form${isFirstInvoicePromo(productConfig)?' of-select-billing-cycle-form--firstinvoicepromo':''}`}>
      <Field className={`of-select-billing-cycle-form__radio`} component={RadioButton} list={getList()} name='selectBillingCycleOption'/>
      <SolidButton className='of-select-billing-cycle__button' type='submit'>Continue</SolidButton>
    </form>
  )
}

SelectBillingCycleForm.propTypes = {
  data: PropTypes.any,
  handleSubmit: PropTypes.func,
  location: PropTypes.object,
  productConfig: PropTypes.object
}

SelectBillingCycleForm = reduxForm({
  form: 'SelectBillingCycleForm'
})(SelectBillingCycleForm)

SelectBillingCycleForm = withRouter(SelectBillingCycleForm)

// This Component is Responsible for all products except domain, 
// it allows the user to select the billing cycle as step in the add to cart process.
let SelectBillingCycle = (props) => {
  const { callback, cid, location } = props
  const dispatch = useDispatch()
  const initFlag = useRef(null)
  const { configurations, form } = useSelector(state => ({
    configurations: state.app.configurations,
    form: state.form
  }))
  const submitCallback = (values) => {
    const { selectBillingCycleOption } = values
    callback(selectBillingCycleOption)
  }
  const initCallback = useCallback(() => {
    if (!initFlag.current) {
      if (configurations && configurations[cid]) {
        const { billing_cycle_id ,selectedProduct} = configurations[cid]
        const {billing_cycle} =  getDataFromURL(location.search)
        if(billing_cycle){
          const {price} = getAttributes(selectedProduct)
          price.forEach(cycle=>{
            if(cycle.name.toLowerCase() === billing_cycle.toLowerCase()){
              dispatch(change('SelectBillingCycleForm', 'selectBillingCycleOption', cycle.billing_cycle_id))
              initFlag.current = true
            }
          })
        }else{
          if (billing_cycle_id) {
            if (form && form.SelectBillingCycleForm && form.SelectBillingCycleForm.values) {
              dispatch(change('SelectBillingCycleForm', 'selectBillingCycleOption', billing_cycle_id))
              initFlag.current = true
            }
          }else{
            //default to monthly
            const {price} = getAttributes(selectedProduct)
            const selectedPrice = getPriceByBillingCycleName(price,MONTHLY)
            if(selectedPrice){
              dispatch(change('SelectBillingCycleForm', 'selectBillingCycleOption', selectedPrice.billing_cycle_id))
            }
            
            initFlag.current = true
          }
        }
      }
    }

  }, [initFlag, configurations, cid, dispatch,form,location])
  const previousForValues = useRef(null)
  const updateSelectedBillingCycle = useCallback(() => {
    if (form && form.SelectBillingCycleForm && form.SelectBillingCycleForm.values) {
      const stringValues = JSON.stringify(form.SelectBillingCycleForm.values)
      if (previousForValues.current !== stringValues && initFlag.current) {
        const { selectBillingCycleOption } = form.SelectBillingCycleForm.values
        updateConfig(configurations, cid, {
          billing_cycle_id: selectBillingCycleOption
        }, dispatch)
        previousForValues.current = stringValues
      }
    }
  }, [form, dispatch, cid, configurations,previousForValues,initFlag])

  useEffect(() => {
    updateSelectedBillingCycle()
    initCallback()
  }, [initCallback,updateSelectedBillingCycle])

  const renderDescription = () => {
    if(getDataFromURL(location.search)){
      const { promo } = getDataFromURL(location.search)
      if (promo) {
        return (
            <Description className={'of-select-billing-cycle__description'}><strong>Please note:</strong> The discount will be automatically applied once you`ve finished
              configuring the product.</Description>
        )
      }
      return (
          <Description className='of-select-billing-cycle__description'>Choose your desired billing duration below.</Description>
      )
    }
    return (<></>)
  }

  return (
    <div className='of-select-billing-cycle of-step'>
      <div className='of-select-billing-cycle__container'>
        <Heading className='of-select-billing-cycle__heading'>Select your billing cycle</Heading>
        {renderDescription()}
        <SelectBillingCycleForm productConfig= {configurations[cid]} onSubmit={submitCallback}/>
      </div>
    </div>
  )
}

SelectBillingCycle = withRouter(SelectBillingCycle)

SelectBillingCycle.propTypes = {
  callback: PropTypes.func,
  cid: PropTypes.any,
  location: PropTypes.object
}

export default SelectBillingCycle
